module.exports = __webpack_public_path__ + "static/postgresql-30da709b57837becdb5f4ec1f9fda3cb.png";